export class User {
  id: number;
  name: string;
  email: string;
}

export class LoginData {
  email: string;
  password: string;

  constructor() {
    this.email = "";
    this.password = "";
  }
}

export class RegisterData {
  name: string;
  email: string;
  password: string;
  referralCode: string;
  plan: string;
  locale: string;

  constructor() {
    this.name = "";
    this.email = "";
    this.password = "";
    this.referralCode = "";
    this.plan = "";
  }
}

export class ResetPasswordData {
  email: string;

  constructor() {
    this.email = "";
  }
}

export class RecoverPasswordData {
  token: string;
  password: string;
  confirm_password: string;

  constructor() {
    this.token = "";
    this.password = "";
    this.confirm_password = "";
  }
}

export class RepeatPasswordType {
  first: string;
  second: string;
}



// WEBPACK FOOTER //
// /app/src/app/core/store/auth/auth.model.ts